import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Buzzer } from './Buzzer';
import { BuzzerSoundWidget } from './BuzzerSoundWidget';

export const buzzerPropertyLayout = LockablePropertyStripLayout<Buzzer>((d, s, o, w, a) => [
    //
    // Color
    w.createColorSelector({
        autoSelect: true,
        groups: true,
        value: a.get('color'),
        text: 'Buzzer Color',
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('color'));
                a.set('color', this.value!);
            });
        }
    }),
    //
    // Sound
    w.createPopout({
        image: 'deqo://icons/hero/music-note',
        text: 'Buzzer Sound',
        value: a.get('sound'),
        ui: BuzzerSoundWidget,
        onSelect() {
            o.update(() => {
                a.set('sound', this.value);
            });
        }
    }),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
